import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft, FiHome } = FiIcons;

const NotFound = () => {
  return (
    <section className="min-h-screen bg-[#FDFCF8] pt-40 pb-24" aria-labelledby="not-found-heading">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-accent-orange mb-6">
          404 · Page not found
        </p>
        <h1 id="not-found-heading" className="text-5xl md:text-7xl font-serif font-black tracking-tight mb-8">
          This page took a wrong turn.
        </h1>
        <p className="max-w-2xl text-black/70 text-lg leading-relaxed mb-10">
          The page you are looking for may have moved, or the address may be incorrect. Let us get you back to a comfortable place.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-3 bg-black text-white px-7 py-4 text-xs font-bold uppercase tracking-[0.2em] hover:bg-accent-orange transition-colors"
        >
          <SafeIcon icon={FiHome} className="w-4 h-4" />
          Return home
          <SafeIcon icon={FiArrowLeft} className="w-4 h-4 rotate-180" />
        </Link>
      </div>
    </section>
  );
};

export default NotFound;